<div #menuEl class="dropdown-menu show context-menu"
     *ngIf="visible"
     [style.left.px]="adjustedX"
     [style.top.px]="adjustedY"
     [style.visibility]="measuring ? 'hidden' : 'visible'">
  <ng-container *ngFor="let action of actions">
    <div class="dropdown-divider" *ngIf="action.separator; else actionItem"></div>
    <ng-template #actionItem>
      <a href="javascript:void(0)"
         role="button"
         class="dropdown-item"
         [class.text-danger]="action.value === 'delete' || action.value === 'wrongly_assigned' || action.value === 'remove_restriction'"
         [class.ps-6]="action.indent"
         (click)="onActionClick(action.value)">
        <i *ngIf="!action.indent" [class]="getActionIcon(action.value)"></i>
        {{ action.label }}
      </a>
    </ng-template>
  </ng-container>
</div>
